import React from 'react';
import { Header, Footer, SEOHead } from '../components';
import { useSEO } from '../hooks/useSEO';
import { pageConfigs } from '../utils/seoConfig';

const TermsOfServicePage: React.FC = () => {
  useSEO(pageConfigs.termsOfService);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead config={pageConfigs.termsOfService} />
      <Header />

      <section className="pt-40 section-padding bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="container-custom">
          <div className="text-center max-w-4xl mx-auto mb-12">
            <h1 className="text-4xl lg:text-5xl font-display font-bold text-slate-900 mb-6">
              Terms of Service
            </h1>
            <p className="text-lg text-slate-600">
              Last updated: November 2024
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-lg max-w-none text-slate-600 space-y-8">
            
            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using the 3 Arrows Media website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                2. Use License
              </h2>
              <p>Permission is granted to temporarily download one copy of the materials (information or software) on 3 Arrows Media website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                3. Disclaimer
              </h2>
              <p>
                The materials on 3 Arrows Media website are provided on an 'as is' basis. 3 Arrows Media makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                4. Limitations
              </h2>
              <p>
                In no event shall 3 Arrows Media or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on 3 Arrows Media's website, even if 3 Arrows Media or an authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                5. Accuracy of Materials
              </h2>
              <p>
                The materials appearing on 3 Arrows Media website could include technical, typographical, or photographic errors. 3 Arrows Media does not warrant that any of the materials on its website are accurate, complete, or current. 3 Arrows Media may make changes to the materials contained on its website at any time without notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                6. Links
              </h2>
              <p>
                3 Arrows Media has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by 3 Arrows Media of the site. Use of any such linked website is at the user's own risk.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                7. Modifications
              </h2>
              <p>
                3 Arrows Media may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                8. Governing Law
              </h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the laws of [Your Jurisdiction], and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-display font-bold text-slate-900 mb-4">
                9. Contact Information
              </h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 bg-slate-50 p-6 rounded-lg">
                <p><strong>3 Arrows Media</strong></p>
                <p>Email: hello@3arrowsmedia.com</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
